<div class="account-center-banner">
  <div class="account-center-banner__content">
    <cpds-badge *ngIf="needsAuthorizationPastdue" class="account-center-banner__badge" [intent]="'warning'"
      >Premium overdue</cpds-badge
    >
    <ng-container *ngFor="let title of bannerTitles">
      <div class="account-center-banner__title">
        {{ title }}
      </div>
    </ng-container>

    <ng-container *ngFor="let subTitle of bannerSubTitles">
      <div class="account-center-banner__subtitle">
        {{ subTitle }}
      </div>
    </ng-container>
    <div *ngIf="buttonText" class="account-center-banner__button-container">
      <button cp-button theme="blue-light" size="large" *ngIf="!loadingEsign; else esign" (click)="onClickAction()">
        {{ buttonText }}
      </button>

      <ng-template #esign><spinner color="white"></spinner></ng-template>
    </div>

    <ng-container
      *ngIf="
        !isLiteTouch && (action === 'TLIC Issued:Waiting for Labs' || action === 'Haven Application:Waiting for Labs')
      "
    >
      <button
        class="button-link account-center-banner__button-link text-link--secondary"
        (click)="openScheduleMedicalExamModal()"
      >
        How do I schedule a medical exam?
      </button>
    </ng-container>

    <ng-container
      *ngIf="
        !isFrozen &&
        (action === 'TLIC Issued:Final Underwriting' ||
          action === 'Manual Underwriting:Final Review' ||
          action === 'Application:Final Review' ||
          action === 'Manual Underwriting:Awaiting APS' ||
          (action === 'Advisor Amendment:Waiting for Advisor Amendment' && !isAccelerated) ||
          action === 'Underwriting:Underwriting')
      "
    >
      <div class="account-center-banner__subtitle account-center-banner__subtitle--underline">
        How long does it take to review?
        <tooltip
          [helpText]="'It usually takes 2-3 days but could be shorter or longer if additional requirements are needed.'"
        ></tooltip>
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        (action === 'Accelerated Application:Waiting for Signature' && !customerSignedApp) ||
        (action === 'TLIC Application:Waiting for Signature' && !customerSignedApp) ||
        (action === 'Haven Application:Waiting for Signature' && !customerSignedApp)
      "
    >
      <button class="button-link account-center-banner__button-link text-link--secondary" (click)="resendEsignEmail()">
        Resend the eSign Email
      </button>
    </ng-container>

    <ng-container
      *ngIf="
        (action === 'Application:Waiting for Issue Acceptance' ||
          action === 'TLIC Issued:Waiting for Policy Acceptance') &&
        insuredEsignRequired
      "
    >
      <button
        class="button-link account-center-banner__button-link text-link--secondary"
        (click)="resendInsuredEsignEmail()"
      >
        Resend the email
      </button>
    </ng-container>
  </div>
</div>
